/*
 * --------------------------------------------------------------------------- *
 * File: utilities.js                                                          *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

exports.fullModalStyle = {
  content: {
    top: "5%",
    left: "5%",
    height: "90%",
    width: "90%",
    backgroundImage: "url('background.jpg')",
    overflow: "auto",
    padding: "20",
    border: "solid",
  },
};

exports.replaceMicrosoftCharacters = (text) => {
  var s = text;
  // smart single quotes and apostrophe
  s = s.replace(/[\u2018|\u2019|\u201A]/g, "'");
  // smart double quotes
  s = s.replace(/[\u201C|\u201D|\u201E]/g, '"');
  // ellipsis
  s = s.replace(/\u2026/g, "...");
  // dashes
  s = s.replace(/[\u2013|\u2014]/g, "-");
  // circumflex
  s = s.replace(/\u02C6/g, "^");
  // open angle bracket
  s = s.replace(/\u2039/g, "");
  // spaces
  s = s.replace(/[\u02DC|\u00A0]/g, " ");
  // Just remove any other non ascii character
  // eslint-disable-next-line no-control-regex
  s = s.replace(/[^\x00-\x7F]/g, "");
  return s;
};

exports.getYyyyMm = (back) => {
  var now = new Date();
  var y = now.getFullYear();
  var m = now.getMonth() + 1 - back;
  while (m < 1) {
    y--;
    m += 12;
  }
  while (m > 12) {
    y++;
    m -= 12;
  }
  m = m < 10 ? "0" + m : "" + m;
  return `${y}${m}`;
};

exports.getDd = (back) => {
  var date = new Date();
  date.setDate(date.getDate() - back);
  return date.getDate();
};

exports.checkAxiosError = (response) => {
  if (response.status !== 200) {
    alert("Network error. Please check your internet connection");
  }
};

var logout = () => {};

exports.registerLogout = (fn) => {
  logout = fn;
};

exports.range = (min, max, step) => {
  step = step || 1;
  var r = [];
  for (var i = min; i < max; i += step) {
    r.push(i);
  }
  return r;
};

exports.addSpaceBeforeCaps = (str) => {
  return str ? str.replace(/[A-Z]/g, " $&").trim() : "";
};

exports.sort_unique = (arr) => {
  if (arr.length === 0) return arr;
  arr = arr.sort(function (a, b) {
    return a * 1 - b * 1;
  });
  var ret = [arr[0]];
  for (var i = 1; i < arr.length; i++) {
    //Start loop at 1: arr[0] can never be a duplicate
    if (arr[i - 1] !== arr[i]) {
      ret.push(arr[i]);
    }
  }
  return ret;
};
